"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var AuthScope_1 = require("./AuthScope");
exports.default = (_a = {},
    _a[AuthScope_1.default.AUTH] = "https://os.vidazoo.com",
    _a[AuthScope_1.default.ADVERTISERS] = "https://os.vidazoo.com/",
    _a[AuthScope_1.default.ALGOTRADER] = "http://algo.cliipa.com",
    _a[AuthScope_1.default.AUTOSCALER] = "https://vidazoo-autoscale.herokuapp.com",
    _a[AuthScope_1.default.BI_DASHBOARD] = "https://bi-dashboard.vidazoo.com",
    _a[AuthScope_1.default.BI_DASHBOARDS] = "https://bi-dashboards-2.vidazoo.com",
    _a[AuthScope_1.default.CAMPAIGN_DUPLICATOR] = "https://algo-campaign-duplicator.herokuapp.com",
    _a[AuthScope_1.default.CAPCHU] = "https://cms.capchu.com",
    _a[AuthScope_1.default.CAPTAINS_LOG] = "https://captain.vidazoo.com",
    _a[AuthScope_1.default.CONNECTIONS] = "https://cbo.vidazoo.com",
    _a[AuthScope_1.default.CONTENT] = "https://console.presspo.com",
    _a[AuthScope_1.default.GAMES] = "https://games.vidazoo.com",
    _a[AuthScope_1.default.MESSAGES] = "https://messages.vidazoo.com",
    _a[AuthScope_1.default.MONEY_BOOKER] = "https://moneybooker.vidazoo.com",
    _a[AuthScope_1.default.NIGHTWATCH] = "https://os.vidazoo.com",
    _a[AuthScope_1.default.OPEN_RTB] = "https://openrtb.vidazoo.com",
    _a[AuthScope_1.default.PLATFORM] = "https://bo.vidazoo.com",
    _a[AuthScope_1.default.PUBLISHERS] = "https://publishers.vidazoo.com",
    _a[AuthScope_1.default.REPORTING] = "https://os.vidazoo.com",
    _a[AuthScope_1.default.SKYNET] = "https://os.vidazoo.com",
    _a[AuthScope_1.default.VAULT] = "https://os.vidazoo.com",
    _a[AuthScope_1.default.VROKU] = "https://ci.vidazoo.com",
    _a[AuthScope_1.default.KIBANA] = "https://0060a39b19ef4910861a84ed8aa54885.us-east-1.aws.found.io:9243",
    _a[AuthScope_1.default.WEB_DIRECTORY] = "https://os.vidazoo.com",
    _a[AuthScope_1.default.SITES] = "https://sites-cms.finallynews.com",
    _a[AuthScope_1.default.FEATURE_TOGGLES] = "https://feature-toggles.vidazoo.com/",
    _a[AuthScope_1.default.USER_NOTIFICATIONS] = "https://os.vidazoo.com/",
    _a[AuthScope_1.default.CMS] = "https://bo.vidazoo.com",
    _a[AuthScope_1.default.ENTERPRISE] = "https://os.vidazoo.com/",
    _a);
